import {
  createContext,
  useState
} from "react";

import alarmConfig from "../config/alarmConfig";

export const AlarmContext =
  createContext();

export function AlarmProvider({
  children
}) {

  const [
    activeAlarms,
    setActiveAlarms
  ] = useState([]);

  // =========================================
  // 🔥 TOGGLE BUZZER
  // =========================================

  const toggleBuzzer = (tag) => {

  setActiveAlarms(prev =>
    prev.map(alarm => {

      if (alarm.tag !== tag) return alarm;

      const newMuteState = !alarm.buzzerOn;

      return {
        ...alarm,
        buzzerOn: newMuteState,

        mutedAt: newMuteState
          ? new Date().toISOString()
          : null,

        muteCount: newMuteState
          ? alarm.muteCount + 1
          : alarm.muteCount
      };
    })
  );
};

  // =========================================
  // 🔥 GLOBAL ALARM ENGINE
  // =========================================

  const evaluateTag = (
    tag,
    value
  ) => {

    const config =
      alarmConfig[tag];

    // =============================
    // SAFETY CHECK
    // =============================

    if (
      !config ||
      !config.ranges
    ) {
      return;
    }

    const {
      description,
      ranges
    } = config;

    let type = null;
    let severity = null;

    // =====================================
    // LOW LOW
    // =====================================

    if (
      ranges.LL !== undefined &&
      value <= ranges.LL
    ) {

      type = "LL Alarm";
      severity = "LL";
    }

    // =====================================
    // LOW
    // =====================================

    else if (
      ranges.L !== undefined &&
      value <= ranges.L
    ) {

      type = "Low Alarm";
      severity = "L";
    }

    // =====================================
    // HIGH HIGH
    // =====================================

    else if (
      ranges.HH !== undefined &&
      value >= ranges.HH
    ) {

      type = "HH Alarm";
      severity = "HH";
    }

    // =====================================
    // HIGH
    // =====================================

    else if (
      ranges.H !== undefined &&
      value >= ranges.H
    ) {

      type = "High Alarm";
      severity = "H";
    }

    // =====================================
    // UPDATE ACTIVE ALARMS
    // =====================================

    setActiveAlarms(prev => {

      const existing =
        prev.find(
          a => a.tag === tag
        );

      // =================================
      // NORMAL CONDITION
      // REMOVE ALARM
      // =================================

      if (!type) {

        return prev.filter(
          a => a.tag !== tag
        );
      }

      // =================================
      // UPDATE EXISTING ALARM
      // =================================

      if (existing) {

        return prev.map(a =>

          a.tag === tag
            ? {
                ...a,
                value,
                type,
                severity
              }
            : a
        );
      }

      // =================================
      // CREATE NEW ALARM
      // =================================

      return [

        ...prev,

        {
          tag,
          description,
          type,
          value,
          severity,

          timestamp:
            new Date()
              .toLocaleString(),

          buzzerOn: true,
          mutedAt: null,
          muteCount: 0
        }
      ];
    });
  };

  // =========================================
  // PROVIDER
  // =========================================

  return (

    <AlarmContext.Provider
      value={{

        activeAlarms,

        evaluateTag,

        toggleBuzzer
      }}
    >

      {children}

    </AlarmContext.Provider>
  );
}